module.exports = __webpack_public_path__ + "img/elastic-logo.e6c44590.svg";